import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { accountReducer } from './account';
import { commentsReducer } from './comments';
import { overlaysReducer } from './dom';
import { projectReducer } from './project';
import { projectFilesReducer } from './projectFiles';
import { projectSupportReducer } from './projectSupport';
import { savingReducer } from './saving';
import { sessionReducer } from './session';

export const store = configureStore({
  reducer: {
    account: accountReducer,
    comments: commentsReducer,
    project: projectReducer,
    projectFiles: projectFilesReducer,
    projectSupport: projectSupportReducer,
    saving: savingReducer,
    overlays: overlaysReducer,
    session: sessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
